module.exports = __webpack_public_path__ + "static/just-diggit.1f994108.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/just-diggit.png
// module id = 579
// module chunks = 35783957827783